import {isSameObject} from "../object/objectUtils";

/**
 * Does a deep equality comparison of any two value
 * @param x Value
 * @param y Value
 * @returns True if they are the same, otherwise False.
 * @example
 * isDeepEqual(0, 0); // true
 * isDeepEqual(0, "0"); // false
 * isDeepEqual(0, false); // false
 * isDeepEqual(false, false); // false
 * isDeepEqual({a: {b: {c: "3"}}}, {a: {b: {c: "3"}}}); // true
 */
function isDeepEqual(x: unknown, y: unknown): boolean {
  if (x === y) {
    return true;
  }

  if (typeof x !== typeof y) {
    return false;
  }

  if (typeof x === "object" && typeof y === "object") {
    return isSameObject(x, y);
  }

  return false;
}

export {isDeepEqual};
